import { alpha, Card, SxProps, Table, TableBody, TableContainer, Theme, useTheme } from '@mui/material';

import { Scrollbar, TableHeadCustom } from '@zeta-core';

export const FieldsHead = [
  { label: 'Information', width: '48%', colSpan: 2, show: true },
  { label: 'Details', minWidth: '48%', show: true },
  { label: '', minWidth: 50, maxWidth: 50, width: 50, show: true },
];

const CommonTableLayout = ({
  tableHead,
  borderToBeGiven,
  children,
  sx,
}: {
  children: JSX.Element;
  borderToBeGiven?: boolean;
  tableHead?: any[];
  sx?: SxProps<Theme>;
}) => {
  const theme = useTheme();
  return (
    <TableContainer component={Card} variant="outlined" sx={{ boxShadow: 'none', ...sx }}>
      <Scrollbar sx={{ '.simplebar-placeholder': { display: 'none' } }}>
        <Table
          sx={{
            '& .MuiTableCell-root': { borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.16)} !important` },
            borderCollapse: 'unset !important',
          }}
        >
          <TableHeadCustom headLabel={tableHead ?? FieldsHead} />
          <TableBody
            sx={{
              td: { p: 0 },
              '& fieldset': { ...(!borderToBeGiven && { border: 'none' }), ...(borderToBeGiven && { margin: 0.5, marginRight: 1 }) },
              'tr:last-child': { borderBottom: 'none !important' },
            }}
          >
            {children}
          </TableBody>
        </Table>
      </Scrollbar>
    </TableContainer>
  );
};

export default CommonTableLayout;
